import DashboardTabMediator from "./DashboardTabMediator";

export default class DashboardRCCETabMediator extends DashboardTabMediator {
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;
    }

    initialize() {
        super.initialize();
    }

    destroy() {
        super.destroy();
    }
    get skin() {
        return this._target;
    }

    get keyDecision() {
        return this._keyDecision;
    }
}